import { Box, Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

// One topic of a settings sheet: its title and purpose on the left, its content on the
// right, a hairline between topics. In a form the content sits on the form grid
// (FormItem); on a details page it is a grid of DetailItems.
const Section = ({
  title,
  subtitle,
  form,
  children,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  form?: boolean;
  children: ReactNode;
}) => (
  <Box
    component="section"
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "220px minmax(0, 1fr)" },
      width: "100%",
      columnGap: 5,
      rowGap: 2,
      py: 4,
      "& + &": { borderTop: 1, borderColor: "divider" },
    }}
  >
    <Box>
      <Typography variant="h6">{title}</Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {form ? (
      <Grid container spacing={3}>
        {children}
      </Grid>
    ) : (
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 3 }}>{children}</Box>
    )}
  </Box>
);

export default Section;
